export const metaConfig = {
  "/company/introduction": {
    title:
      "회사 소개 | 생성형 AI · RAG · RPA 지능형 업무자동화 전문기업 | 레인보우브레인 Rainbow Bbrain",
    description:
      "레인보우브레인은 생성형 AI, RAG, RPA 기술을 바탕으로 지식 검색, 문서 자동화, 반복 업무 제거 등 지능형 자동화를 실현합니다. AI는 더 이상 도구가 아닌, 당신의 업무 파트너입니다.",
    ogTitle: "생성형 AI · RAG · RPA 기반 지능형 업무자동화 | 레인보우브레인",
    ogDescription:
      "레인보우브레인은 생성형 AI, RAG, RPA 기술을 바탕으로 지식 검색, 문서 자동화, 반복 업무 제거 등 지능형 자동화를 실현합니다. AI는 더 이상 도구가 아닌, 당신의 업무 파트너입니다.",
    canonical: "https://rbrain.co.kr/company/introduction",

    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "AboutPage",
          "@id": "https://rbrain.co.kr/company/introduction#webpage",
          url: "https://rbrain.co.kr/company/introduction",
          name: "회사 소개 | 생성형 AI · RAG · RPA 지능형 업무자동화 전문기업 | 레인보우브레인 Rainbow Brain",
          description:
            "레인보우브레인은 생성형 AI, RAG, RPA 기술을 바탕으로 지식 검색, 문서 자동화, 반복 업무 제거 등 지능형 자동화를 실현합니다. AI는 더 이상 도구가 아닌, 당신의 업무 파트너입니다.",
          isPartOf: { "@id": "https://rbrain.co.kr/#website" },
          inLanguage: "ko-KR",
        },
        {
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "홈",
              item: "https://rbrain.co.kr",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "회사소개",
              item: "https://rbrain.co.kr/company/introduction",
            },
          ],
        },
      ],
    },
  },
  "/company/support": {
    title:
      "AI ·RAG· RPA 자동화 솔루션 도입 문의  | 레인보우브레인 Rainbow Bbrain",
    description:
      "생성형 AI, RAG, RPA 기반의 업무 자동화 솔루션 도입을 위한 상담 및 기술 문의를 남겨주세요. 전문 컨설턴트가 신속하게 대응합니다.",
    ogTitle: "AI · RPA 자동화 솔루션 상담 요청 | 레인보우브레인",
    ogDescription:
      "생성형 AI, RAG, RPA 기반의 업무 자동화를 위한 기술 상담과 솔루션 도입 문의를 받습니다. 지금 바로 문의해보세요.",
    canonical: "https://rbrain.co.kr/company/support",

    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "ContactPage",
          "@id": "https://rbrain.co.kr/company/support#webpage",
          url: "https://rbrain.co.kr/company/support",
          name: "AI · RAG · RPA 자동화 솔루션 도입 문의 | 레인보우브레인 Rainbow Brain",
          description:
            "생성형 AI, RAG, RPA 기반의 업무 자동화 솔루션 도입을 위한 상담 및 기술 문의를 남겨주세요. 전문 컨설턴트가 신속하게 대응합니다.",
          isPartOf: { "@id": "https://rbrain.co.kr/#website" },
          inLanguage: "ko-KR",
        },
        {
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "홈",
              item: "https://rbrain.co.kr",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "문의하기",
              item: "https://rbrain.co.kr/company/support",
            },
          ],
        },
      ],
    },
  },

  "/business/aisolution": {
    title:
      "AI 기반 업무 자동화 솔루션 | 생성형 AI · RAG · RPA | 레인보우브레인 Rainbow Brain",
    description:
      "생성형 AI, RAG, RPA 기술을 바탕으로 지식 검색, 문서 처리, 반복 업무 자동화를 실현하는 AI 기반 업무 자동화 솔루션을 제공합니다.",
    ogTitle: "AI 기반 업무 자동화 솔루션 | 레인보우브레인",
    ogDescription:
      "생성형 AI, RAG, RPA 기술을 바탕으로 지식 검색, 문서 처리, 반복 업무 자동화를 실현하는 AI 기반 업무 자동화 솔루션을 제공합니다.",
    canonical: "https://rbrain.co.kr/business/aisolution",

    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://rbrain.co.kr/business/aisolution#webpage",
          url: "https://rbrain.co.kr/business/aisolution",
          name: "AI 기반 업무 자동화 솔루션 | 생성형 AI · RAG · RPA | 레인보우브레인 Rainbow Brain",
          description:
            "생성형 AI, RAG, RPA 기술을 바탕으로 지식 검색, 문서 처리, 반복 업무 자동화를 실현하는 AI 기반 업무 자동화 솔루션을 제공합니다.",
          isPartOf: { "@id": "https://rbrain.co.kr/#website" },
          inLanguage: "ko-KR",
        },
        {
          "@type": "Service",
          "@id": "https://rbrain.co.kr/business/aisolution#service",
          name: "AI 기반 업무 자동화 솔루션",
          serviceType: "AI · RAG · RPA",
          description: "AI 기반 업무 자동화 솔루션 소개",
          provider: { "@id": "https://rbrain.co.kr/#organization" },
          areaServed: "KR",
          offers: {
            "@type": "Offer",
            availability: "https://schema.org/InStock",
            url: "https://rbrain.co.kr/company/support",
          },
        },
        {
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "홈",
              item: "https://rbrain.co.kr",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "AI SOLUTION",
              item: "https://rbrain.co.kr/business/aisolution",
            },
          ],
        },
      ],
    },
  },

  "/business/eureka": {
    title: "유레카브레인 | 커머스 데이터 자동화 솔루션",
    description:
      "유레카브레인은 커머스 시장에서 소비재 브랜드가 선제 대응할 수 있도록 데이터를 빠르게 수집·분석하고 대응을 자동화하는 AI 기반 데이터 자동화 솔루션입니다.",
    ogTitle: "유레카브레인 | 커머스 데이터 자동화 솔루션",
    ogDescription:
      "EurekaBrain은 커머스 시장에서 소비재 브랜드가 선제 대응할 수 있도록 데이터를 빠르게 수집·분석하고 대응을 자동화하는 AI 데이터 솔루션입니다.",
    canonical: "https://rbrain.co.kr/business/eureka",

    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://rbrain.co.kr/business/eureka#webpage",
          url: "https://rbrain.co.kr/business/eureka",
          name: "EurekaBrain | 유레카브레인 커머스 데이터 자동화 솔루션",
          description:
            "EurekaBrain은 커머스 시장에서 소비재 브랜드가 선제 대응할 수 있도록 데이터를 빠르게 수집·분석하고 대응을 자동화하는 AI 기반 데이터 자동화 솔루션입니다.",
          isPartOf: { "@id": "https://rbrain.co.kr/#website" },
          inLanguage: "ko-KR",
        },
        {
          "@type": "SoftwareApplication",
          "@id": "https://rbrain.co.kr/business/eureka#application",
          name: "EurekaBrain",
          alternateName: "유레카브레인",
          applicationCategory: "BusinessApplication",
          operatingSystem: "Web",
          description:
            "AI 기반 데이터 자동화 솔루션으로 커머스 시장에서 소비재 브랜드가 선제 대응할 수 있도록 데이터 수집·분석·대응을 자동화합니다.",
          provider: { "@id": "https://rbrain.co.kr/#organization" },
          offers: {
            "@type": "Offer",
            availability: "https://schema.org/InStock",
            url: "https://rbrain.co.kr/company/support",
          },
        },
        {
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "홈",
              item: "https://rbrain.co.kr",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "솔루션",
              item: "https://rbrain.co.kr/business/aisolution",
            },
            {
              "@type": "ListItem",
              position: 3,
              name: "EurekaBrain (유레카브레인)",
              item: "https://rbrain.co.kr/business/eureka",
            },
          ],
        },
      ],
    },
  },

  "/business/trend": {
    title: "트렌드센싱보드 | AI 기반 트렌드 수집·분석·요약 툴",
    description:
      "트렌드센싱보드는 AI가 데이터를 자동 수집·분석·요약하여 빠른 트렌드 파악을 지원하는 서비스 툴입니다. 데이터를 기반으로 비즈니스 의사결정을 강화하세요.",
    ogTitle: "트렌드센싱보드 | 트렌드 자동 수집·분석·요약 서비스",
    ogDescription:
      "트렌드센싱보드는 데이터를 자동으로 수집·분석·요약하여 빠른 트렌드 파악과 비즈니스 의사결정을 지원하는 AI 기반 툴입니다.",
    canonical: "https://rbrain.co.kr/business/trend",

    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://rbrain.co.kr/business/trend#webpage",
          url: "https://rbrain.co.kr/business/trend",
          name: "Trend Sensing Board | 트렌드센싱보드 AI 기반 트렌드 수집·분석·요약 툴",
          description:
            "Trend Sensing Board는 AI가 데이터를 자동 수집·분석·요약하여 빠른 트렌드 파악을 지원하는 서비스 툴입니다. 또한 데이터를 기반으로 비즈니스 의사결정을 강화합니다.",
          isPartOf: { "@id": "https://rbrain.co.kr/#website" },
          inLanguage: "ko-KR",
        },
        {
          "@type": "SoftwareApplication",
          "@id": "https://rbrain.co.kr/business/trend#application",
          name: "Trend Sensing Board",
          alternateName: "트렌드센싱보드",
          applicationCategory: "BusinessApplication",
          operatingSystem: "Web",
          description:
            "AI 기반 데이터 자동 수집·분석·요약을 통해 빠른 트렌드 파악과 비즈니스 의사결정을 지원하는 서비스 툴",
          provider: { "@id": "https://rbrain.co.kr/#organization" },
          offers: {
            "@type": "Offer",
            availability: "https://schema.org/InStock",
            url: "https://rbrain.co.kr/company/support",
          },
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://rbrain.co.kr/business/trend#breadcrumb",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "홈",
              item: "https://rbrain.co.kr/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "솔루션",
              item: "https://rbrain.co.kr/business/aisolution",
            },
            {
              "@type": "ListItem",
              position: 3,
              name: "Trend Sensing Board (트렌드센싱보드)",
              item: "https://rbrain.co.kr/business/trend",
            },
          ],
        },
      ],
    },
  },

  "/business/eurekagenai": {
    title:
      "EurekaGenAI | LLM · RAG 기반 지식 자동화 솔루션 | 레인보우브레인 Rainbow Brain",
    description:
      "EurekaGenAI는 LLM과 RAG 기술을 기반으로 문서 기반 질의응답, 지식 검색, 업무 지원을 자동화하는 기업 맞춤형 AI 솔루션입니다.",
    ogTitle: "EurekaGenAI | LLM · RAG 기반 지식 자동화 솔루션",
    ogDescription:
      "EurekaGenAI는 기업의 내부 문서를 기반으로 지식 검색과 Q&A를 자동화하는 LLM · RAG 기반 AI 솔루션입니다.",
    canonical: "https://rbrain.co.kr/business/eurekagenai",

    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://rbrain.co.kr/business/eurekagenai#webpage",
          url: "https://rbrain.co.kr/business/eurekagenai",
          name: "EurekaGenAI | LLM · RAG 기반 지식 자동화 솔루션 | 레인보우브레인 Rainbow Brain",
          description:
            "EurekaGenAI는 LLM과 RAG 기술을 기반으로 문서 기반 질의응답, 지식 검색, 업무 지원을 자동화하는 기업 맞춤형 AI 솔루션입니다.",
          isPartOf: { "@id": "https://rbrain.co.kr/#website" },
          inLanguage: "ko-KR",
        },
        {
          "@type": "Service",
          "@id": "https://rbrain.co.kr/business/eurekagenai#service",
          name: "EurekaGenAI",
          serviceType: "LLM · RAG 지식 자동화",
          description: "생성형 AI 솔루션 EurekaGenAI 소개",
          provider: { "@id": "https://rbrain.co.kr/#organization" },
          areaServed: "KR",
          offers: {
            "@type": "Offer",
            availability: "https://schema.org/InStock",
            url: "https://rbrain.co.kr/company/support",
          },
        },
        {
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "홈",
              item: "https://rbrain.co.kr",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "EurekaGenAI",
              item: "https://rbrain.co.kr/business/eurekagenai",
            },
          ],
        },
      ],
    },
  },

  "/business/rpa": {
    title:
      "RPA 솔루션 | Automation Anywhere 공식 파트너사| 반복 업무 제거를 위한 자동화 기술 | 레인보우브레인 Rainbow Brain",
    description:
      "레인보우브레인은 글로벌 RPA 리더 Automation Anywhere의 공식 파트너로, 기업 맞춤형 자동화 컨설팅 및 구축 서비스를 제공합니다.",
    ogTitle:
      "RPA 자동화 솔루션 | Automation Anywhere 공식 파트너 | 레인보우브레인",
    ogDescription:
      "레인보우브레인은 Automation Anywhere의 공식 파트너로서 RPA 기반 업무 자동화 구축과 컨설팅을 제공합니다. 반복 업무를 효율적으로 줄여보세요.",
    canonical: "https://rbrain.co.kr/business/rpa",

    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://rbrain.co.kr/business/rpa#webpage",
          url: "https://rbrain.co.kr/business/rpa",
          name: "RPA 솔루션 | Automation Anywhere 공식 파트너사 | 반복 업무 제거를 위한 자동화 기술 | 레인보우브레인 Rainbow Brain",
          description:
            "레인보우브레인은 글로벌 RPA 리더 Automation Anywhere의 공식 파트너로, 기업 맞춤형 자동화 컨설팅 및 구축 서비스를 제공합니다.",
          isPartOf: { "@id": "https://rbrain.co.kr/#website" },
          inLanguage: "ko-KR",
        },
        {
          "@type": "Service",
          "@id": "https://rbrain.co.kr/business/rpa#service",
          name: "RPA 솔루션",
          serviceType: "로보틱 프로세스 자동화",
          description: "RPA 기술 개요 및 적용 사례 소개",
          provider: { "@id": "https://rbrain.co.kr/#organization" },
          areaServed: "KR",
          offers: {
            "@type": "Offer",
            availability: "https://schema.org/InStock",
            url: "https://rbrain.co.kr/company/support",
          },
        },
        {
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "홈",
              item: "https://rbrain.co.kr",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "RPA",
              item: "https://rbrain.co.kr/business/rpa",
            },
          ],
        },
      ],
    },
  },
  "/business/rpaportal": {
    title:
      "RPA Portal | RPA 운영 · 성과 · 내재화 통합 관리 플랫폼 | 레인보우브레인 Rainbow Brain",
    description:
      "RPA Portal은 Automation Anywhere 기반의 RPA 운영, 성과, 추진을 통합 관리하는 플랫폼입니다. Bot 모니터링, ROI 통계, 협업 기능으로 안정적이고 효율적인 RPA 환경을 제공합니다.",
    ogTitle: "RPA Portal | RPA 운영부터 내재화까지 통합 관리",
    ogDescription:
      " RPA Portal은 RPA 운영, 성과 측정, Bot 모니터링, 커뮤니티 기능까지 제공하는 Automation Anywhere 기반 통합 관리 플랫폼입니다.",
    canonical: "https://rbrain.co.kr/business/rpaportal",

    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://rbrain.co.kr/business/rpaportal#webpage",
          url: "https://rbrain.co.kr/business/rpaportal",
          name: "RPA Portal | RPA 운영 · 성과 · 내재화 통합 관리 플랫폼 | 레인보우브레인 Rainbow Brain",
          description:
            "RPA Portal은 Automation Anywhere 기반의 RPA 운영, 성과, 추진을 통합 관리하는 플랫폼입니다. Bot 모니터링, ROI 통계, 협업 기능으로 안정적이고 효율적인 RPA 환경을 제공합니다.",
          isPartOf: { "@id": "https://rbrain.co.kr/#website" },
          inLanguage: "ko-KR",
        },
        {
          "@type": "Service",
          "@id": "https://rbrain.co.kr/business/rpaportal#service",
          name: "RPA Portal",
          serviceType: "RPA 운영 통합 플랫폼",
          description: "RPA 관련 리소스 및 도구 제공 포털 서비스 소개",
          provider: { "@id": "https://rbrain.co.kr/#organization" },
          areaServed: "KR",
          offers: {
            "@type": "Offer",
            availability: "https://schema.org/InStock",
            url: "https://rbrain.co.kr/company/support",
          },
        },
        {
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "홈",
              item: "https://rbrain.co.kr",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "RPA PORTAL",
              item: "https://rbrain.co.kr/business/rpaportal",
            },
          ],
        },
      ],
    },
  },
  "/business/voucher": {
    title:
      "바우처 지원 | 생성형 AI · RPA 솔루션 도입 정부지원 안내 | 레인보우브레인 Rainbow Brain",
    description:
      "정부지원 바우처로 생성형 AI, RPA 솔루션을 도입하세요. 레인보우브레인은 AI 바우처 등 다양한 사업을 통해 비용 부담 없이 업무 자동화를 실현할 수 있도록 지원합니다.",
    ogTitle: "정부지원 바우처로 AI · RPA 솔루션을 도입하세요 | 레인보우브레인",
    ogDescription:
      "정부지원 바우처 사업을 통해 생성형 AI, RPA 기반 업무 자동화 솔루션을 비용 부담 없이 도입할 수 있습니다. 지금 레인보우브레인에서 상담받아보세요.",
    canonical: "https://rbrain.co.kr/business/voucher",

    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://rbrain.co.kr/business/voucher#webpage",
          url: "https://rbrain.co.kr/business/voucher",
          name: "바우처 지원 | 생성형 AI · RPA 솔루션 도입 정부지원 안내 | 레인보우브레인 Rainbow Brain",
          description:
            "정부지원 바우처로 생성형 AI, RPA 솔루션을 도입하세요. 레인보우브레인은 AI 바우처 등 다양한 사업을 통해 비용 부담 없이 업무 자동화를 실현할 수 있도록 지원합니다.",
          isPartOf: { "@id": "https://rbrain.co.kr/#website" },
          inLanguage: "ko-KR",
        },
        {
          "@type": "Service",
          "@id": "https://rbrain.co.kr/business/voucher#service",
          name: "바우처 지원",
          serviceType: "정부지원 바우처",
          description: "정부지원 바우처 사업 관련 안내 및 신청 유도",
          provider: { "@id": "https://rbrain.co.kr/#organization" },
          areaServed: "KR",
          offers: {
            "@type": "Offer",
            availability: "https://schema.org/InStock",
            url: "https://rbrain.co.kr/company/support",
          },
        },
        {
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "홈",
              item: "https://rbrain.co.kr",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "VOUCHER",
              item: "https://rbrain.co.kr/business/voucher",
            },
          ],
        },
      ],
    },
  },

  "/media/news": {
    title: "레인보우브레인 뉴스룸 | 기업 공식 소식과 보도자료 | Rainbow Brain",
    description:
      "레인보우브레인의 기업 활동과 공식 보도자료를 전하는 뉴스룸입니다. 생성형 AI · RPA 기반 자동화 전문 기업의 최신 소식을 확인하세요.",
    ogTitle: "레인보우브레인 뉴스룸 | 기업 소식과 보도자료",
    ogDescription:
      "레인보우브레인의 공식 뉴스룸입니다. 보도자료, 기업 활동, 기술 브리핑 등 브랜드 중심 소식을 모았습니다.",
    canonical: "https://rbrain.co.kr/media/news",

    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "CollectionPage",
          "@id": "https://rbrain.co.kr/media/news#webpage",
          url: "https://rbrain.co.kr/media/news",
          name: "레인보우브레인 뉴스룸 | 기업 공식 소식과 보도자료 | Rainbow Brain",
          description:
            "레인보우브레인의 기업 활동과 공식 보도자료를 전하는 뉴스룸입니다. 생성형 AI · RPA 기반 자동화 전문 기업의 최신 소식을 확인하세요.",
          isPartOf: { "@id": "https://rbrain.co.kr/#website" },
          inLanguage: "ko-KR",
        },
        {
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "홈",
              item: "https://rbrain.co.kr",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "NEWS",
              item: "https://rbrain.co.kr/media/news",
            },
          ],
        },
      ],
    },
  },

  "/media/case": {
    title:
      "사례 소개 | 생성형 AI · RPA 기업 업무 적용 사례 | 레인보우브레인 Rainbow Brain",
    description:
      "레인보우브레인은 생성형 AI, RAG, RPA 기술을 실제 기업 업무에 적용한 다양한 사례를 소개합니다. 자동화 성과와 실질적 도입 효과를 확인해보세요.",
    ogTitle: "생성형 AI · RPA 기반 기업 도입 사례 | 레인보우브레인",
    ogDescription:
      "레인보우브레인의 생성형 AI · RPA 기술이 실제 기업에 어떻게 적용되었는지 확인해보세요. 자동화 성과와 업무 변화 사례를 소개합니다.",
    canonical: "https://rbrain.co.kr/media/case",

    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "CollectionPage",
          "@id": "https://rbrain.co.kr/media/case#webpage",
          url: "https://rbrain.co.kr/media/case",
          name: "사례 소개 | 생성형 AI · RPA 기업 업무 적용 사례 | 레인보우브레인 Rainbow Brain",
          description:
            "레인보우브레인은 생성형 AI, RAG, RPA 기술을 실제 기업 업무에 적용한 다양한 사례를 소개합니다. 자동화 성과와 실질적 도입 효과를 확인해보세요.",
          isPartOf: { "@id": "https://rbrain.co.kr/#website" },
          inLanguage: "ko-KR",
        },
        {
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "홈",
              item: "https://rbrain.co.kr",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "USE CASE",
              item: "https://rbrain.co.kr/media/case",
            },
          ],
        },
      ],
    },
  },

  "/media/casebook": {
    title:
      "도입 사례 리포트 (케이스북) | 생성형 AI · RPA 도입 사례 리포트 | 레인보우브레인 Rainbow Brain",
    description:
      "레인보우브레인의 생성형 AI, RAG, RPA 기술을 활용한 실제 고객사 도입 사례를 리포트 형식으로 제공합니다. 케이스북을 통해 성과 중심의 업무 자동화 사례를 확인해보세요.",
    ogTitle:
      "실제 도입 사례 리포트 | 생성형 AI · RPA 케이스북 | 레인보우브레인",
    ogDescription:
      "생성형 AI · RPA 기술을 기반으로 기업들이 경험한 실질적인 자동화 성과를 리포트로 정리했습니다. 레인보우브레인의 케이스북에서 실제 사례를 확인해보세요.",
    ogImage: "http://file.rbrain.co.kr/2025-09-26T05-40-29-333Z-casebook_ogimage.png",
    canonical: "https://rbrain.co.kr/media/casebook",

    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "CollectionPage",
          "@id": "https://rbrain.co.kr/media/casebook#webpage",
          url: "https://rbrain.co.kr/media/casebook",
          name: "도입 사례 리포트 (케이스북) | 생성형 AI · RPA 도입 사례 리포트 | 레인보우브레인 Rainbow Brain",
          description:
            "레인보우브레인의 생성형 AI, RAG, RPA 기술을 활용한 실제 고객사 도입 사례를 리포트 형식으로 제공합니다. 케이스북을 통해 성과 중심의 업무 자동화 사례를 확인해보세요.",
          isPartOf: { "@id": "https://rbrain.co.kr/#website" },
          inLanguage: "ko-KR",
        },
        {
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "홈",
              item: "https://rbrain.co.kr",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "CASEBOOK",
              item: "https://rbrain.co.kr/media/casebook",
            },
          ],
        },
      ],
    },
  },

  "/media/conference": {
    title:
      "컨퍼런스 · 웨비나 · 세미나 | 생성형 AI · RPA 공식 행사 아카이브 | 레인보우브레인 Rainbow Brain",
    description:
      "레인보우브레인이 주최하거나 참여한 생성형 AI · RPA 관련 컨퍼런스와 세미나 정보를 확인하세요. 기업 자동화 혁신을 위한 실전 인사이트를 공유합니다.",
    ogTitle:
      "생성형 AI · RPA 컨퍼런스 아카이브 | 레인보우브레인 공식 세미나 모음",
    ogDescription:
      "생성형 AI와 RPA 기반 자동화를 주제로 한 레인보우브레인의 컨퍼런스, 세미나, 웨비나 자료를 한곳에 모았습니다. 발표 내용과 현장 인사이트를 확인해보세요.",
    canonical: "https://rbrain.co.kr/media/conference",

    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "CollectionPage",
          "@id": "https://rbrain.co.kr/media/conference#webpage",
          url: "https://rbrain.co.kr/media/conference",
          name: "컨퍼런스 · 웨비나 · 세미나 | 생성형 AI · RPA 공식 행사 아카이브 | 레인보우브레인 Rainbow Brain",
          description:
            "레인보우브레인이 주최하거나 참여한 생성형 AI · RPA 관련 컨퍼런스와 세미나 정보를 확인하세요. 기업 자동화 혁신을 위한 실전 인사이트를 공유합니다.",
          isPartOf: { "@id": "https://rbrain.co.kr/#website" },
          inLanguage: "ko-KR",
        },
        {
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "홈",
              item: "https://rbrain.co.kr",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "CONFERENCE",
              item: "https://rbrain.co.kr/media/conference",
            },
          ],
        },
      ],
    },
  },

  "/media/newsletter": {
    title:
      "RPA+AI 뉴스레터 | 생성형 AI · RPA 인사이트 정리 | 레인보우브레인 Rainbow Brain",
    description:
      "생성형 AI, RAG, RPA 기술의 최신 인사이트와 자동화 트렌드를 정리해 전합니다. 기술과 비즈니스의 연결을 뉴스레터로 확인해보세요.",
    ogTitle: "RPA+AI 뉴스레터 | 생성형 AI · RPA 트렌드 한눈에",
    ogDescription:
      "생성형 AI · RAG · RPA 중심의 자동화 인사이트를 제공합니다. 업무에 바로 적용할 수 있는 정보들을 받아보세요.",
    canonical: "https://rbrain.co.kr/media/newsletter",

    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "CollectionPage",
          "@id": "https://rbrain.co.kr/media/newsletter#webpage",
          url: "https://rbrain.co.kr/media/newsletter",
          name: "RPA+AI 뉴스레터 | 생성형 AI · RPA 인사이트 정리 | 레인보우브레인 Rainbow Brain",
          description:
            "생성형 AI, RAG, RPA 기술의 최신 인사이트와 자동화 트렌드를 정리해 전합니다. 기술과 비즈니스의 연결을 뉴스레터로 확인해보세요.",
          isPartOf: { "@id": "https://rbrain.co.kr/#website" },
          inLanguage: "ko-KR",
        },
        {
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "홈",
              item: "https://rbrain.co.kr",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "NEWSLETTER",
              item: "https://rbrain.co.kr/media/newsletter",
            },
          ],
        },
      ],
    },
  },

  "/partners/partners": {
    title:
      "기술 파트너 | 생성형 AI · RPA 협력 생태계 | 레인보우브레인 Rainbow Brain",
    description:
      "글로벌 기술 기업과의 협력 생태계를 통해 자동화 솔루션을 고도화 합니다.",
    ogTitle: "레인보우브레인의 기술 파트너십 | 생성형 AI · RPA 협력 네트워크",
    ogDescription:
      "생성형 AI 및 RPA 분야에서 글로벌 파트너사와 협력해 자동화를 실현하는 생태계 소개",
    canonical: "https://rbrain.co.kr/partners/partners",

    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "CollectionPage",
          "@id": "https://rbrain.co.kr/partners/partners#webpage",
          url: "https://rbrain.co.kr/partners/partners",
          name: "기술 파트너 | 생성형 AI · RPA 협력 생태계 | 레인보우브레인 Rainbow Brain",
          description:
            "글로벌 기술 기업과의 협력 생태계를 통해 자동화 솔루션을 고도화 합니다.",
          isPartOf: { "@id": "https://rbrain.co.kr/#website" },
          inLanguage: "ko-KR",
        },
        {
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "홈",
              item: "https://rbrain.co.kr",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "PARTNERS",
              item: "https://rbrain.co.kr/partners/partners",
            },
          ],
        },
      ],
    },
  },
  "/newslettersubscribe": {
    title:
      "RPA+AI 뉴스레터 구독 신청 | 생성형 AI · RPA 자동화 인사이트 | 레인보우브레인 Rainbow Brain",
    description:
      "생성형 AI · RPA 자동화 트렌드를 빠르게 받아보고 싶다면 구독하세요. 인사이트, 사례, 기술 해설 제공",
    ogTitle: "RPA+AI 뉴스레터 구독 | 생성형 AI · RPA 트렌드 정기 업데이트",
    ogDescription:
      "생성형 AI · RPA 중심의 인사이트와 실무 적용 사례를 빠르게 받아보세요.",
    canonical: "https://rbrain.co.kr/newslettersubscribe",

    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://rbrain.co.kr/newslettersubscribe#webpage",
          url: "https://rbrain.co.kr/newslettersubscribe",
          name: "RPA+AI 뉴스레터 구독 신청 | 생성형 AI · RPA 자동화 인사이트 | 레인보우브레인 Rainbow Brain",
          description:
            "생성형 AI · RPA 자동화 트렌드를 빠르게 받아보고 싶다면 구독하세요. 인사이트, 사례, 기술 해설 제공",
          isPartOf: { "@id": "https://rbrain.co.kr/#website" },
          inLanguage: "ko-KR",
        },
        {
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "홈",
              item: "https://rbrain.co.kr",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "뉴스레터 구독",
              item: "https://rbrain.co.kr/newslettersubscribe",
            },
          ],
        },
      ],
    },
  },

  "/sign": {
    title:
      "서명 페이지 | 생성형 AI · RPA 협력 생태계 | 레인보우브레인 Rainbow Brain",
    description: "전자서명 페이지입니다.",
    ogTitle:
      "서명 페이지 | 생성형 AI · RPA 협력 생태계 | 레인보우브레인 Rainbow Brain",
    ogDescription: "전자서명 페이지입니다.",
  },
  "/privacy-policy": {
    title: "개인정보처리방침 | 생성형 AI · RPA | 레인보우브레인 Rainbow Brain",
    description: "개인정보처리방침 페이지 입니다.",
    ogTitle:
      "개인정보처리방침 | 생성형 AI · RPA | 레인보우브레인 Rainbow Brain",
    ogDescription: "개인정보처리방침 페이지 입니다.",
  },

  "/expo/rpa": {
    title:
      "Expo RPA | 생성형 AI · RPA 자동화 인사이트 | 레인보우브레인 Rainbow Brain",
    description: "Expo RPA 페이지입니다.",
  },
  "/expo/rpa1": {
    title:
      "Expo RPA1 | 생성형 AI · RPA 자동화 인사이트 | 레인보우브레인 Rainbow Brain",
    description: "Expo RPA1 상세 페이지입니다.",
  },
  "/expo/rpa2": {
    title:
      "Expo RPA2 | 생성형 AI · RPA 자동화 인사이트 | 레인보우브레인 Rainbow Brain",
    description: "Expo RPA2 상세 페이지입니다.",
  },

  "/aiexpo": {
    title:
      "AI Expo | 생성형 AI · RPA 자동화 인사이트 | 레인보우브레인 Rainbow Brain",
    description: "AI Expo Korea 참가 안내 페이지입니다",
  },
  "/aiexpoLLM": {
    title:
      "AI Expo LLM | 생성형 AI · RPA 자동화 인사이트 | 레인보우브레인 Rainbow Brain",
    description: "LLM 세션 상세 안내 페이지입니다",
  },
  "/aiexpoECommerce": {
    title:
      "AI Expo E-Commerce | 생성형 AI · RPA 자동화 인사이트 | 레인보우브레인 Rainbow Brain",
    description: "E-Commerce 세션 정보 페이지입니다",
  },
  "/aiexpoChatGPT": {
    title:
      "AI Expo ChatGPT | 생성형 AI · RPA 자동화 인사이트 | 레인보우브레인 Rainbow Brain",
    description: "ChatGPT 세션 정보 페이지입니다",
  },
};

export const defaultMeta = {
  title:
    "생성형 AI · RAG · RPA 기반 지능형 업무자동화 전문기업 | 레인보우브레인 Rainbow Brain",
  description:
    "레인보우브레인은 생성형 AI, RAG, RPA 기술을 기반으로 문서 자동화, 지식 검색, 스마트 리포팅 등 지능형 업무 자동화를 제공하는 전문 기업입니다.",
  ogTitle: "생성형 AI · RAG · RPA 기반 업무 자동화 전문기업 | 레인보우브레인 ",
  ogDescription:
    "레인보우브레인은 생성형 AI, RAG, RPA 기술을 기반으로 문서 자동화, 지식 검색, 스마트 리포팅 등 지능형 업무 자동화를 제공하는 전문 기업입니다.",
  canonical: "https://rbrain.co.kr",

  schema: {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": "https://rbrain.co.kr/#organization",
        name: "레인보우브레인",
        alternateName: "Rainbow Brain",
        url: "https://rbrain.co.kr",
        logo: {
          "@type": "ImageObject",
          url: "https://rbrain.co.kr/static/media/logo_512.c6d10014a21e5ec2b68c.png",
        },
        sameAs: [
          "https://blog.naver.com/rainbow-brain",
          "https://www.youtube.com/@rainbowbrain_youtube",
          "https://www.facebook.com/rbrain.co.kr",
        ],
        contactPoint: [
          {
            "@type": "ContactPoint",
            contactType: "customer service",
            telephone: "+82-70-4680-6090",
            faxNumber: "+82-70-4015-3929",
            email: "contact@rbrain.co.kr",
            areaServed: "KR",
            availableLanguage: ["ko"],
          },
        ],
        address: {
          "@type": "PostalAddress",
          streetAddress: "은행로 37, 기계회관 본관 4층",
          addressLocality: "영등포구",
          addressRegion: "서울특별시",
          postalCode: "07238",
          addressCountry: "KR",
        },
      },
      {
        "@type": "WebSite",
        "@id": "https://rbrain.co.kr/#website",
        url: "https://rbrain.co.kr",
        name: "레인보우브레인",
        publisher: { "@id": "https://rbrain.co.kr/#organization" },
        inLanguage: "ko-KR",
        potentialAction: {
          "@type": "SearchAction",
          target: "https://rbrain.co.kr/search?q={query}",
          "query-input": "required name=query",
        },
      },
    ],
  },
};
